import { adminApiFetch } from './apiService';

export const warehouseService = {
  // 列表
  fetchList: async () => {
    const response = await adminApiFetch('warehouses', { method: 'GET' });
    return response.json();
  },
};

export default warehouseService;
